import React from 'react';

import { IIconProps, TIconType } from '../interface';

const UncheckWhiteIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='21'
			viewBox='0 0 20 21'
			width='20'
			{...props?.innerSvgProps}
		>
			<rect
				fill='white'
				height='19'
				rx='3.5'
				stroke='#48428A'
				width='19'
				x='0.5'
				y='1'
			/>
		</svg>
	);
};

export default UncheckWhiteIcon;
